import {Text, View} from "react-native";
import * as React from "react";
import {PaymentButton} from "./dashboard/shared/payment-button";
import {TransparentBox} from "../../../ui/transparent-box";

export const SubscriptionFinished = ({
    onRenew
}) => <View style={{marginTop: 80, marginBottom: 20, padding: 50 }}>
    <TransparentBox>
        <Text style={{color: 'white', fontSize: 30, textAlign: 'center', marginBottom: 0}}>Your Subscription</Text>
        <Text style={{color: 'white', fontSize: 25, textAlign: 'center', marginBottom: 10}}>is finished</Text>
        <Text style={{color: 'white', fontSize: 14, textAlign: 'center', marginBottom: 10, lineHeight: 25 }}>
            To continue to use WeCycle services, you can renew for 6 months
        </Text>

        <PaymentButton product="subscribe" onPay={onRenew}>Renew</PaymentButton>
    </TransparentBox>
</View>